import { z } from 'zod';

export type SignupFormEventType =
  | 'SignupFormStepChange'
  | 'SignupFormButtonClick'
  | 'SignupFormFieldFocus'
  | 'SignupFormFieldBlur'
  | 'RegistrationCompleted';

// Signup form event payload schemas
export const SignupFormStepChangePayloadSchema = z.undefined();

export const SignupFormFieldFocusPayloadSchema = z.object({
  field: z.string(),
});

export const SignupFormFieldBlurPayloadSchema = z.object({
  field: z.string(),
});

export const SignupFormButtonClickPayloadSchema = z.object({
  button: z.string(),
});

export const RegistrationCompletedPayloadSchema = z.object({
  pre_filled: z.boolean(),
  success: z.boolean(),
  user_type: z.enum(['direct_seller']),
});

export type SignupFormEventTypePayloadMap = {
  SignupFormStepChange: z.infer<typeof SignupFormStepChangePayloadSchema>;
  SignupFormFieldFocus: z.infer<typeof SignupFormFieldFocusPayloadSchema>;
  SignupFormFieldBlur: z.infer<typeof SignupFormFieldBlurPayloadSchema>;
  SignupFormButtonClick: z.infer<typeof SignupFormButtonClickPayloadSchema>;
  RegistrationCompleted: z.infer<typeof RegistrationCompletedPayloadSchema>;
};

export const SignupFormEventSchemaMap = {
  SignupFormStepChange: SignupFormStepChangePayloadSchema,
  SignupFormFieldFocus: SignupFormFieldFocusPayloadSchema,
  SignupFormFieldBlur: SignupFormFieldBlurPayloadSchema,
  SignupFormButtonClick: SignupFormButtonClickPayloadSchema,
  RegistrationCompleted: RegistrationCompletedPayloadSchema,
};
